<template>
    <div>
        <v-subheader>Fisiere</v-subheader>
        <v-file-input
            v-model="fileUpload"
            label="Click pentru adaugare"
            multiple
        ></v-file-input>

        <template v-if="files instanceof Array && files.length">
            <v-list-item v-for="(mediaItem, mIndex) in files" :key="mIndex" link @click="downloadAttachment(mediaItem)">
                <v-list-item-content>
                    <v-list-item-title>{{ mediaItem.file_name }}</v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                    <v-btn icon outlined color="error" @click="deleteAttachment(mediaItem)">
                        <v-icon>mdi-delete</v-icon>
                    </v-btn>
                </v-list-item-action>
            </v-list-item>
        </template>
    </div>
</template>

<script>
export default {
    props: {
        endpoint: {
            type: String,
            required: true
        },
        files: {
            type: Array,
            default () {
                return []
            }
        }
    },
    data () {
        return {
            fileUpload: []
        }
    },
    watch: {
        fileUpload: {
            handler (val) {
                let that = this
                if (val === undefined || (val instanceof Array && !val.length)) return
                that.loading = true
                let formData = new FormData();
                for (let i = 0; i < val.length; ++i) {
                    formData.append(`attachments[${i}]`, val[i]);
                }
                axios.post(endpoint, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }).then(function({data}){
                    that.form.media = []
                    for (let f = 0; f < that._.get(data, 'data', []).length; ++f) {
                        that.form.media.push(data.data[f])
                    }
                    that.fileUpload = []
                    that.showSuccess();
                })
                    .catch(function(){
                        that.showError('A aparut o eroare necunoscuta. Va rugam contactati echipa de suport.')
                    })
                    .finally(() => {
                        that.loading = false
                    })
            }
        }
    },
    methods: {
        async downloadAttachment(item) {
            this.loading = true
            return window.axios.get(`${this.endpoint}/${item.id}`, {
                responseType: 'blob'
            }).then((response) => {
                const contentDisposition = this._.get(response, 'headers.content-disposition')
                const filename = contentDisposition.split("filename=")[1];
                const downloadUrl = window.URL.createObjectURL(new Blob([response?.data]));
                const link = document.createElement('a');
                link.href = downloadUrl;
                link.setAttribute('download', filename); //any other extension
                document.body.appendChild(link);
                link.click();
                link.remove();
            }).catch((err) => {
                console.error(err)
            }).finally(() => {
                this.loading = false
            })
        },
        async deleteAttachment (item) {
            let that = this
            this.loading = true
            return window.axios.delete(`${this.endpoint}/${item.id}`).then(({data}) => {
                that.form.media = []
                for (let f = 0; f < that._.get(data, 'data', []).length; ++f) {
                    that.form.media.push(data.data[f])
                }
            }).catch((err) => {
                console.error(err)
            }).finally(() => {
                this.loading = false
            })
        }
    }
}
</script>
